import {useCallback, useState} from "react";
import {DynamicDataTableFilter, FilterSettings} from "./types";
import {buildUrlWithFilterParams, getDefaultFilterValues} from "./DataFilter";

export  const useFilterSettings = function<T>(
  searchParams: URLSearchParams,
  availableFilters: DynamicDataTableFilter<T>[],
  navigate: (route: string) => void
){
  const [filterValues, setFilterValues] = useState<FilterSettings<T>>({} as FilterSettings<T>)
  const setFilterValue = useCallback((filter: keyof T | string, value: string) => {
    setFilterValues(old => {
      const filters = {
        ...old,
        [filter]: value
      }
      navigate(buildUrlWithFilterParams(filters))
      return filters
    })
  }, [setFilterValues])

  const getDefaultFilterValue = useCallback((filterProperty: keyof T | string) => {
    return getDefaultFilterValues(searchParams, availableFilters, filterProperty)
  }, [searchParams, availableFilters])

  const getFilterValue = useCallback((filter: keyof T | string) => filterValues[filter] ?? getDefaultFilterValue(filter), [getDefaultFilterValue, filterValues])
  return {
    setFilterValue,
    getFilterValue,
  }
}